import { CheckCircle, Error } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { S4DProductComparison } from '../utils/s4dProductComparison';

type Props = {
  comparison: S4DProductComparison | undefined;
  ingredientId: number;
  isCompared: boolean;
  fontSize?: number;
};

/** How one recipe ingredient matches the S4D recipe. */
export const S4DRecipeStatusIcon = (props: Props): JSX.Element => {
  const { comparison, ingredientId, isCompared, fontSize } = props;
  const { t } = useTranslation();
  const sx = fontSize ? { fontSize } : undefined;

  if (!isCompared) {
    return (
      <Tooltip title={t('Ingredient is not compared against the S4D recipe')}>
        <CheckCircle color="disabled" sx={sx} />
      </Tooltip>
    );
  }

  if (comparison?.missingToppings.some((missing) => missing.ingredientId === ingredientId)) {
    return (
      <Tooltip title={t('Topping missing from S4D recipe')}>
        <Error color="error" sx={sx} />
      </Tooltip>
    );
  }

  const countMismatch = comparison?.toppingCountMismatches.find((mismatch) => mismatch.ingredientId === ingredientId);
  if (countMismatch) {
    return (
      <Tooltip
        title={t('S4D recipe topping count {{ingredientCount}}', {
          ingredientCount: countMismatch.s4dCount,
        })}
      >
        <Error color="warning" sx={sx} />
      </Tooltip>
    );
  }

  return <CheckCircle color="success" sx={sx} />;
};
